<template>
  <div class="infos">
    <i
      v-for="(author, i) in items"
      class="icon-user"
      :class="{ 'me-2': i === items.length - 1 }"
      :key="i"
    ></i>
    <span>
      {{ items.map((author) => author.name).join(", ") }}
    </span>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      required: false,
      default: () => [],
    },
    authCenter: {
      type: Boolean,
      default: false,
    },
  },
};
</script>

<style lang="scss" scoped>
.infos {
  @media (max-width: 991.97px) {
    display: none;
  }

  font-family: "Inter";
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 15px;

  text-transform: uppercase;

  color: #767676;
}
</style>
